import { render, staticRenderFns } from "./virtual-account.vue?vue&type=template&id=6fa7ac2e&scoped=true&"
import script from "./virtual-account.vue?vue&type=script&lang=js&"
export * from "./virtual-account.vue?vue&type=script&lang=js&"
import style0 from "./virtual-account.vue?vue&type=style&index=0&id=6fa7ac2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7ac2e",
  null
  
)

export default component.exports